{
  "name": "@highnoteplatform/secure-inputs",
  "version": "1.8.1",
  "description": "Secure input fields for your customer.",
  "source": "src/index.ts",
  "access": "public",
  "main": "lib/index.js",
  "module": "lib/esm/module.js",
  "types": "lib/types.d.ts",
  "files": [
    "lib",
    "README.md"
  ],
  "scripts": {
    "clean": "rimraf lib dist",
    "prebuild": "npm run clean",
    "build": "PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache",
    "postbuild": "node ../../scripts/fix-node-env.js",
    "prepublishOnly": "npm run build",
    "test": "jest",
    "test:watch": "jest --watch",
    "prepack": "npm run build",
    "predev": "npm run clean",
    "dev": "parcel watch --port 3005 --hmr-port 2005 --no-cache --dist-dir=lib"
  },
  "author": "packages@highnote.com",
  "license": "MIT",
  "homepage": "https://highnote.com",
  "devDependencies": {
    "@highnoteplatform/types": "*",
    "@types/jest": "28.1.8",
    "@types/uuid": "^9.0.1",
    "@types/jsdom": "21.1.1",
    "@types/node": "^22.0.0",
    "eslint-plugin-jest": "27.2.1",
    "jest": "^28.1.3",
    "jest-environment-jsdom": "^29.5.0",
    "jsdom": "21.1.1",
    "ts-jest": "28.0.8"
  },
  "targets": {
    "main": {
      "includeNodeModules": [
        "@highnoteplatform/types"
      ],
      "optimize": true
    },
    "module": {
      "includeNodeModules": [
        "@highnoteplatform/types"
      ],
      "optimize": true
    }
  },
  "dependencies": {
    "uuid": "^11.0.0"
  }
}
